
<template>
  <div
    class="lg:w-full text-center hover:shadow-lg"
    :class="cardColor"
  > 
    <nuxt-link
      :to="url"
      :class="linkClass"
    >
      <RePictureSet
        :image="image"
        :image-class="imageClass + ' lazyload'"
        sizes="320px"
      />
      <h2 class="font-source-serif-pro font-semibold text-red text-xl mt-4 leading-snug">
        {{ title }}
      </h2>
      <slot />
    </nuxt-link>
  </div>
</template>

<script>
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'

export default {
    components: { 
    RePictureSet,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    image: {
      required: true
    },
    url: {
      type: String,
      default: ""
    },
    imageClass: {
      type: String
    },
    linkClass:{
      type: String,
      default: ""
    },
    cardColor:{
      type: String,
      default: "bg-white"
    }
  }
};
</script>
